export default {"src":"/_next/static/media/sport-en-spel.e7e849a9.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};